import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=7c3ba358&scoped=true&"
import script from "./Allergens.vue?vue&type=script&lang=js&"
export * from "./Allergens.vue?vue&type=script&lang=js&"
import style0 from "./Allergens.vue?vue&type=style&index=0&id=7c3ba358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3ba358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDialog,VFlex,VIcon,VLayout,VRow})
